<template>
  <div class="common-report-table">
    <template v-if="tableData.headers">
      <el-tabs
        :class="{'show-shadow': tabIndex !== '0' }"
        v-if="isShowToggleTabs"
        v-model="tabIndex"
        @tab-click="handleTabClick">
        <el-tab-pane
          v-for="(header, idx) in tableData.headers"
          :key="idx"
          :label="header.name"
          :name="`${idx}`">
        </el-tab-pane>
      </el-tabs>
      <section :class="{'scroll-content': isShowToggleTabs}" @scroll="onScroll">
        <div
          :ref="`scroll-item-${index}`"
          class="scroll-item"
          v-for="(header, index) in tableData.headers"
          :key="index">
          <template v-if="type === 1">
            <div class="title">{{ header.name }}</div>
            <el-tooltip
              v-if="header.desc"
              popper-class="table-title-tooltip"
              effect="dark"
              placement="bottom-start">
              <div
                slot="content"
                class="tooltip-item"
                v-for="(desc, idx) in header.desc"
                :key="idx">
                {{ desc }}
              </div>
              <i class="icon-question"></i>
            </el-tooltip>
          </template>
          <el-table
            border
            stripe
            :data="tableData.data"
            style="width:100%"
            :height="!isShowToggleTabs && totalPages > 1 ? '75vh' : 'auto'">
            <el-table-column
              v-for="(item, index) in header.titleList"
              :align="tableAlign"
              :show-overflow-tooltip="true"
              :sortable="item.sortable"
              :key="index"
              :prop="item.key"
              :label="item.name"
              :fixed="index === 0 ? 'left' : false"
              min-width="140">
              <template slot="header">
                {{ item.name }}
                <el-tooltip
                  v-if="showHeaderTip && item.illustration"
                  effect="dark"
                  placement="bottom-start"
                  :content="`${item.illustration}`">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-button
                  v-if="+item.isClick && !['', '-'].includes(scope.row[item.key])"
                  type="text"
                  @click="handleDetail(scope.row, item)">
                  {{ scope.row[item.key] | filterNum(item.key) }}
                  <i class="el-icon-arrow-right"></i>
                </el-button>
                <span v-else>
                  {{ scope.row[item.key] | filterNum(item.key)  }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging-wrapper" v-if="showPagination && totalPages >= 1">
          <el-pagination
            background
            @current-change="handlePageNoChange"
            :current-page.sync="pageNo"
            :page-size="pageSize"
            layout="prev, pager, next, slot, jumper"
            :total="totalAmount">
            <span class="page-indicator">
              <em>{{ pageNo }}</em>/{{ totalPages }}
            </span>
          </el-pagination>
        </div>
      </section>
    </template>
    <div v-else class="data-empty-block">暂无数据</div>
  </div>
</template>

<script>
import { numThousand } from '@/utils'
import pagination from '@/mixins/pagination'

/**
 * table数据渲染组件
 * @props {Boolean} showPagination 是否展示分页组件
 * @props {String} url 请求的url
 * @props {Object} filterParams 搜索参数
 */

export default {
  name: 'common-report-table',
  mixins: [pagination],
  props: {
    type: {
      type: Number,
      default: 1 // 1-panel 2-detail
    },
    tableAlign: {
      type: String,
      default: 'right',
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: ''
    },
    filterParams: {
      type: Object,
      default: () => {}
    },
    showHeaderTip: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      tableData: {},
      tabIndex: '0',
    }
  },
  filters: {
    filterNum(value, key) {
      key = key.trim()
      if (value === '' || value === '-') return '-'
      if (value === '-999') return '未知'
      if (['NaN', 'infinity', '-infinity'].includes(value)) return '-'
      if (key.substr(0, 2) === 'is') return value === '1' ? '是' : '否'
      if (key.indexOf('Id') > -1) return value
      if (key.indexOf('Rate') > -1) {
        if (value <= 1) return Number(value * 100).toFixed(2) + '%'
        return Number(value).toFixed(2) + '%'
      }
      return numThousand(value)
    }
  },
  computed: {
    isShowToggleTabs() {
      return this.tableData.headers && this.tableData.headers.length > 1
    },
  },
  created() {
    this.initPagination('fetchData', false)
  },
  methods: {
    fetchData(init = false, filterParams) {
      this.resetData()
      if (!this.url) return
      if (init) this.pageNo = 1
      const loading = this.$loading({
        lock: true,
        target: '.common-report-table'
      });
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...filterParams,
        ...this.filterParams,
      }
      this.fetch
        .post(this.url, params)
        .then((res) => {
          if (res.data) {
            this.tableData = res.data.filter(_ => _.type === 'table')[0] || {}
            this.tableData.headers.forEach(header => {
              header.desc = header.titleList
                .filter(item => item.key !== 'date')
                .map(_ => _.name + ': ' + _.illustration)
              return header
            })
            this.totalAmount = this.tableData.total
            this.$emit('update:export', !(this.tableData.data && this.tableData.data.length))
          }
          loading.close();
        })
        .catch(() => {
          loading.close();
        })
    },
    resetData() {
      this.tableData = []
      this.tabIndex = '0'
    },
    handleDetail(row, item) {
      this.$emit('detail', { row, item })
    },
    onScroll(e) {
      if (!this.isShowToggleTabs) return
      let scrollItems = document.querySelectorAll('.scroll-item')
      for(let i = scrollItems.length - 1; i >= 0; i--) {
        if (e.target.scrollTop === 0) {
          this.tabIndex = '0'
          break
        }
        let judge = e.target.scrollTop >= scrollItems[i].offsetTop - scrollItems[0].offsetTop - 300
        if (judge) {
          this.tabIndex = i.toString()
          break
        }
      }
    },
    handleTabClick(tab) {
      let target = document.querySelector('.scroll-content')
      let scrollItems = document.querySelectorAll('.scroll-item')
      // 判断滚动条是否滚动到底部
      if (target.scrollHeight <= target.scrollTop + target.clientHeight) {
        this.tabIndex = tab.index.toString()
      }
      // 锚点元素待滚动的距离
      let totalY = scrollItems[tab.index].offsetTop - scrollItems[0].offsetTop
      target.scrollTo({ top: totalY, behavior: 'smooth' })
    },
  }
}
</script>

<style lang="scss">
.common-report-table {
  .el-tabs {
    margin-top: -12px;
    &.show-shadow {
      box-shadow: 0 2px 4px -2px rgba(0,0,0,0.10);
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__item {
      font-size: 14px;
      color: rgba(0,0,0,0.60);
      &.is-active {
        color: rgba(0,0,0,0.90);
        font-weight: 600;
      }
    }
  }
  .scroll-content {
    max-height: 800px;
    overflow-y: auto;
    margin-top: 4px;
    .scroll-item {
      margin-bottom: 12px;
      background: #fff;
      border-radius: 10px;
      padding: 16px 0;
      box-sizing: border-box;
      .title {
        font-size: 16px;
        color: rgba(0,0,0,0.87);
        line-height: 22px;
        display: inline-block;
        font-weight: 600;
        margin-bottom: 16px;
        margin-right: 6px;
      }
    }
  }
}

</style>